// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export const GO = '[Router] Go';
export const BACK = '[Router] Back';
export const FORWARD = '[Router] Forward';

export interface RouteAction {
  path: Array<any>;
  query?: object;
  extras?: NavigationExtras;
}
export class Go implements Action {
  public readonly type = GO;

  constructor(public payload: RouteAction) {}
}

export class Back implements Action {
  public readonly type = BACK;
}

export class Forward implements Action {
  public readonly type = FORWARD;
}

export type Actions = Go | Back | Forward;
